export const COORDINATION_ID = 4
export const INTERFEDERATION_ID = 7
export const FEDERATION_ID = 1
export const SECTION_ID = 2
export const CELL_ID = 3
export const PRESIDENCE_ID = 5
export const SECRETARY_ID = 6
